import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationValuations } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Flex } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { EmptyState } from '@dealstack/frontend/shared/components/EmptyState/EmptyState.tsx';

interface Props {
	createNewValuationButtonAction: () => void;
}

export const ValuationsEmpty = ({ createNewValuationButtonAction }: Props) => {
	const tValuations = useTranslationValuations();

	return (
		<Flex justify="center" align="center" w="100%" h="100%">
			<EmptyState icon="es-radar" title={tValuations('main_container_empty_content_copy')}>
				<Button
					leftSection={<Icon variant="add" size="lg" />}
					variant="default"
					onClick={() => createNewValuationButtonAction()}
					data-testid={TEST_ELEMENT_IDS.VALUATION_CREATE_BUTTON}
				>
					{tValuations('create_new_valuation_cta')}
				</Button>
			</EmptyState>
		</Flex>
	);
};
